import { render, staticRenderFns } from "./ManageWebsites.vue?vue&type=template&id=8b87a0f0&"
import script from "./ManageWebsites.vue?vue&type=script&lang=js&"
export * from "./ManageWebsites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports